import React from "react";
import { History, Pencil } from "lucide-react";
import { BALANCE_COLS, fmtNum, fmtSigned } from "./balanceFields";

const BalanceCell = ({ row, col, onEdit }) => {
  const v = row[col.key];
  const adj = col.key === "overtime" ? row.overtime_adjust : 0;
  return (
    <button onClick={() => onEdit(row, col)} title={`Modifica ${col.label}`} data-testid={`balance-cell-${row.id}-${col.key}`}
      className={`group/cell w-full text-right px-2 py-1.5 rounded-sm font-bold tabular-nums transition-colors hover:bg-[#16345c]/10 focus:outline-none focus:ring-2 focus:ring-[#ff7e00] ${v < 0 ? "text-[#e30613]" : "text-[#16345c]"}`}>
      <Pencil size={11} className="inline mr-1 opacity-0 group-hover/cell:opacity-60 transition-opacity" />
      {fmtNum(v)}
      {adj !== 0 && <span className="block text-[10px] font-semibold text-amber-600" data-testid={`balance-ot-adjust-${row.id}`}>rett. {fmtSigned(adj)}</span>}
    </button>
  );
};

const TotalsRow = ({ rows }) => (
  <tr className="border-t-2 border-[#16345c]/20 bg-[#f7f9fc] font-black text-[#16345c]" data-testid="balances-totals">
    <td className="sticky left-0 z-10 bg-[#f7f9fc] px-4 py-3 text-[12px] uppercase">Totale ({rows.length})</td>
    {BALANCE_COLS.map((c) => (
      <td key={c.key} className="px-3 py-3 text-right tabular-nums">{fmtNum(rows.reduce((s, r) => s + (r[c.key] || 0), 0))}</td>
    ))}
    <td />
  </tr>
);

export const BalancesTable = ({ rows, loading, year, onEdit, onHistory }) => (
  <div className="bg-white border border-gray-200 rounded-lg overflow-x-auto" data-testid="balances-table-wrap">
    <table className="w-full min-w-[1020px] text-[13px]" data-testid="balances-table">
      <thead className="bg-[#16345c] text-white text-[11px] uppercase tracking-wide">
        <tr>
          <th className="sticky left-0 z-10 bg-[#16345c] text-left px-4 py-3">Dipendente</th>
          {BALANCE_COLS.map((c) => (
            <th key={c.key} className="text-right px-3 py-3 whitespace-nowrap">
              {c.short}{c.key === "overtime" ? ` ${year}` : ""}
              <span className="block text-[10px] font-semibold text-white/60 normal-case">{c.unit}</span>
            </th>
          ))}
          <th className="px-3 py-3 text-center">Storico</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} className="group border-t border-gray-100 hover:bg-[#f7f9fc] transition-colors" data-testid={`balance-row-${r.id}`}>
            <td className="sticky left-0 z-10 bg-white group-hover:bg-[#f7f9fc] px-4 py-2 transition-colors">
              <div className="font-bold text-[#16345c] whitespace-nowrap">{r.name}</div>
              <div className="text-[11px] text-gray-400 whitespace-nowrap">{r.matricola}{r.dept ? ` · ${r.dept}` : ""}</div>
            </td>
            {BALANCE_COLS.map((c) => <td key={c.key} className="px-1.5 py-1"><BalanceCell row={r} col={c} onEdit={onEdit} /></td>)}
            <td className="px-3 py-1 text-center">
              <button onClick={() => onHistory(r)} title="Storico modifiche" data-testid={`balance-history-${r.id}`}
                className="w-8 h-8 inline-flex items-center justify-center rounded-sm text-gray-500 hover:text-[#16345c] hover:bg-[#16345c]/10 transition-colors"><History size={15} /></button>
            </td>
          </tr>
        ))}
        {rows.length > 0 && <TotalsRow rows={rows} />}
      </tbody>
    </table>
    {!loading && rows.length === 0 && <div className="px-4 py-10 text-center text-[13px] text-gray-400" data-testid="balances-empty">Nessun dipendente trovato</div>}
    {loading && <div className="px-4 py-10 text-center text-[13px] text-gray-400" data-testid="balances-loading">Caricamento saldi...</div>}
  </div>
);
